import { render } from "./vagentdivide.vue?vue&type=template&id=1139726b&scoped=true"
import script from "./vagentdivide.vue?vue&type=script&lang=js"
export * from "./vagentdivide.vue?vue&type=script&lang=js"

import "./vagentdivide.vue?vue&type=style&index=0&id=1139726b&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1139726b"]])

export default __exports__